import { render } from "./FooterSocialNetworksLinks.vue?vue&type=template&id=7919de9a&scoped=true"
const script = {}

import "./FooterSocialNetworksLinks.vue?vue&type=style&index=0&id=7919de9a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7919de9a"]])

export default __exports__